import {CtModelRouteData} from "@ctsolution/ct-framework";

export const ActivityTypeRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("activityType");
